<template>
  <div class="kiosk-receipt">
    <h2>Thanks for your order</h2>
    <h3>Scan here to generate a receipt...</h3>
    <qr-code id="qr" :contents="qrCode" position-ring-color="var(--text-colour)" position-center-color="var(--action-colour)" module-color="var(--text-colour)">
      <!-- eslint-disable-next-line -->
      <img id="qr-beamy" src="/beamyLogo.png" slot="icon" />
    </qr-code>
    <div class="countdown" >
      <p>QR Code will expire in {{ countdown }} seconds</p>
    </div>
    <button @click.stop.prevent="resetQRCode">Start Order</button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "KioskReciept",
  props: {
    // Define your props here
  },
  data() {
    return {
      countdown: 30,
      qrCode: "",
      complete: false,
      timer: null,
    };
  },

  async mounted() {
    await this.waitForCustomElement();

    if (this.getKioskOrderDetails && this.getKioskOrderDetails.orderID) {
      this.generateQR(this.getKioskOrderDetails.orderID);
    } else {
      this.$router.push({ path: "/startOrder" });
    }
  },

  computed: {
    ...mapGetters({
      getKioskOrderDetails: "getKioskOrderDetails",
    }),
  },

  methods: {
    async waitForCustomElement() {
      if (customElements.get("qr-code")) {
        return;
      }

      const timeout = new Promise((_, reject) => setTimeout(() => reject(new Error("QR Code custom element timeout")), 5000));

      try {
        await Promise.race([customElements.whenDefined("qr-code"), timeout]);
      } catch (error) {
        this.$router.push({ path: "/startOrder" });
      }
    },

    generateQR(id) {
      // add /qrcode on end of this.qrCode if wanting to use as image
      this.qrCode = `https://flaskapi-gpvubq4nta-ts.a.run.app/receipt/${window.localStorage.getItem("company")}/${window.localStorage.getItem("site")}/${
        this.getKioskOrderDetails.orderID
      }`;
      this.complete = true;
      this.countdown = 30; // Reset the countdown
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.resetQRCode();
        }
      }, 1000); // Update countdown every second
    },

    resetQRCode() {
      this.qrCode = "";
      this.complete = false;
      clearInterval(this.timer);
      this.$store.dispatch("setKioskDetails", {
        orderType: "",
        orderDetails: "",
        orderID: "",
      });
      this.$router.push({ path: "/startOrder" });
    },
  },
};
</script>

<style scoped>
.kiosk-receipt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--background-colour);
  color: var(--text-colour);
}

h2, h3 {
  margin: 0;
  padding: 0.5rem;
  text-align: center;
}

.countdown {
  margin: 20px;
  font-size: 1.2rem;
}

button {
  background-color: var(--action-colour);
  color: var(--secondary-text-colour);
  border: none;
  box-shadow: var(--box-shadow);;
  padding: 2rem 5rem;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1rem;
}

#qr {
  margin: 20px;
}

#qr-beamy {
  width: 100%;
  border-radius: 10px;
  /* height: 50px; */
}
</style>
